import { useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import { CustomButton, Text, CustomTable } from "../../shared/uiComponents";
import { useCheckPermission } from "../../shared/Helpers/hooks";
import SearchBar from "../../components/SearchBar";
import { Container, Header } from "../../components/StyledComponents";
import { AdminTypes } from "../../components/Menu";
import { PERMISSIONS } from "../../App/constants";
import MobileView from "./mobileView";
import { TableBody, Headers } from "./tableInfo";

import { DispatchProperties, useSelector } from "../../redux/store";
import { getAdmins } from "../../redux/State/userSlice";

const Admins = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch<DispatchProperties>();
  const { permissionGranted } = useCheckPermission(PERMISSIONS.USER.CREATE);

  const [params] = useSearchParams();

  const admins = useSelector((state) => state.user.admins);
  const loading = useSelector((state) => state.user.loading);

  useEffect(() => {
    const page = params.get("page") || "1";
    const pageSize = params.get("pageSize") || "8";
    const orderBy = params.get("orderBy") || "";
    const direction = params.get("direction") || "";
    const searchString = params.get("search") || "";

    dispatch(getAdmins({ page, pageSize, orderBy, direction, searchString }));
  }, [params, dispatch]);

  const addAdminHandler = () => {
    window.localStorage.setItem("formType", AdminTypes[0]);
    navigate("/admin/new");
  };

  return (
    <Container>
      <Header>
        <Text title={"Admin"} size="mediumBold" />
        <Header>
          {permissionGranted && (
            <CustomButton
              title={"Add admin"}
              className={"marginRight16"}
              onClick={addAdminHandler}
            />
          )}
          <SearchBar />
        </Header>
      </Header>
      <CustomTable
        headers={Headers}
        data={admins}
        TableBody={TableBody}
        loading={loading}
      />
      <MobileView {...admins} />
    </Container>
  );
};

export default Admins;
